"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when forbidden access to course
 * @param {string} courseId
 */
class CourseForbiddenError extends client_library_1.ExtendableError {
    constructor(courseId) {
        super(`course: ${courseId} forbidden access`);
        this.courseId = courseId;
    }
}
exports.default = CourseForbiddenError;
//# sourceMappingURL=CourseForbiddenError.js.map